import classnames from "classnames";

import style from "./style.module.scss";
import ControlBase from "../control-base";
import type { ControlTextProps } from "../../types";

function ControlText({ label, touched, error, ...props }: ControlTextProps) {
  return (
    <ControlBase label={label} touched={touched} error={error}>
      {(id) => (
        <input
          type="text"
          className={classnames(style.input, {
            [style.hasError]: error && touched,
          })}
          id={id}
          {...props}
        />
      )}
    </ControlBase>
  );
}

export default ControlText;
